// removed by extract-text-webpack-plugin
module.exports = {"tooltip":"_2ogvirpgbnSmPKJ63dU0Zi","BelowLeft":"_3ku3zGbjondqcRGJj1969"};


//////////////////
// WEBPACK FOOTER
// ./src/elements/tooltip/tooltip.scss
// module id = 434
// module chunks = 0